// Copyright (c) 2022 Siemens

/**
 * @module js/oPINEngineeringModulePrereq
 */
import _appCtxSvc from 'js/appCtxService';
import localeService from 'js/localeService'
import oPINRQuickComposerService from 'js/oPINRQuickComposerModule/oPINRQuickComposerService'
import oPINRQCService from 'js/oPINRuntimeModule/oPINRQCService'
import apmRESTService from 'js/commonUtilsModule/apmRESTService';
import utilService from 'js/commonUtilsModule/utilService'
import momUtils from "js/MomUtilsService"
const exports = {};

function changePrereqStatus( howMuch = 0 ) {
    let reqS = _appCtxSvc.getCtx("prereqState") || 0;
    reqS +=howMuch;
    _appCtxSvc.updateCtx("prereqState",reqS)
}

///oPINEngineeringSublocation Prerequisite

/**
 * Check if AssetPerformance feature is enabled
 * @returns {boolean} true if AssetPerformance is enabled
 */
function checkFeatures() {
    const fList = _appCtxSvc.getCtx('FeaturesListNames');
    return (fList.indexOf('AssetPerformance') !== -1);
}

exports.oPINEngineeringSublocationPrereq = function() {
    if (!checkFeatures() ){
        //momUtils.navigateTo("missingPage",null)
        alert("AssetPerformance feature not available")
        return Promise.reject(new Error("AssetPerformance feature not available"))
    }
    console.debug("###Prereq Enter oPINEngineeringSublocationPrereq")
    changePrereqStatus(1);
    _appCtxSvc.updateCtx("location.titles",{
        browserTitle:"Opcenter Intelligence",
        browserSubTitle:"Asset Performance Project"
    })

    const readdableStopJustificationItems = _appCtxSvc.getCtx('readdableStopJustificationItems');
    let p1 = Promise.resolve();
    if ( readdableStopJustificationItems === null || readdableStopJustificationItems === undefined ) {
        const TT = {
            "subTree": "oPINEngineeringMessages",
            "justificationItems": "oPINEngineeringMessages",
            "justificationItemsDesc": "oPINEngineeringMessages",
            "subTreeDesc": "oPINEngineeringMessages"
        };
        let TTTrad = Object.getOwnPropertyNames(TT).map(x => {
            return localeService.getLocalizedText(TT[x], x)
        });
        p1 = Promise.all(TTTrad).then(tradArray => {
            Object.getOwnPropertyNames(TT).forEach((x, index) => {
                TT[x] = tradArray[index]
            });
            const stopJustificationItems = {
                "type": "INTEGER",
                "dbValue": [{
                        "propDisplayValue": TT["subTree"],
                        "propDisplayDescription": TT["subTreeDesc"],
                        "propInternalValue": 1,
                        "hasChildren": false,
                        "children": {},
                        "sel": false
                    },
                    {
                        "propDisplayValue": TT["justificationItems"],
                        "propDisplayDescription": TT["justificationItemsDesc"],
                        "propInternalValue": 2,
                        "hasChildren": false,
                        "children": {},
                        "sel": false
                    }
                ]
            };
            const readdableStopJustificationItems = [];
            readdableStopJustificationItems[1] = TT["subTree"];
            readdableStopJustificationItems[2] = TT["justificationItems"];
            _appCtxSvc.registerCtx('readdableStopJustificationItems', readdableStopJustificationItems);
            _appCtxSvc.updateCtx('stopJustificationTypes', stopJustificationItems);        
        });
    }
    return p1.then(x =>{
        changePrereqStatus(-1);
        console.debug("###Prereq Exit oPINEngineeringSublocationPrereq");        
    })
}
exports.oPINEngineeringProjectsPrereq = function () {
    console.debug("###Prereq Enter oPINEngineeringProjectsPrereq")
    changePrereqStatus(1);
    _appCtxSvc.unRegisterCtx("currentEngPrj");
    changePrereqStatus(-1);
    console.debug("###Prereq Exit oPINEngineeringProjectsPrereq");        
    return Promise.resolve();
}
exports.oPINEngineeringProjectSublocationPrereq = function () {
    if ( !checkFeatures() ) {
        //momUtils.navigateTo("missingPage",null)
        alert("AssetPerformance feature not available")
        return Promise.reject(new Error("AssetPerformance feature not available"))
    }
    console.debug("###Prereq Enter oPINEngineeringProjectSublocationPrereq")
    changePrereqStatus( 1 );
    const currentEngPrj = _appCtxSvc.getCtx("currentEngPrj");
    let p1 = Promise.resolve();
    if( currentEngPrj === null || currentEngPrj === undefined ) {
        const apiProject = _appCtxSvc.getCtx("oPINProjectsConfig").oPINEngineering.apiProject;
        //"ctx.oPINProjectsConfig.oPINEngineering.apiProject + 'projects/' + stateParams.engprojectid"
        var projectK = _appCtxSvc.getCtx("state").processed.engprojectid;
        
        //p1 = utilService.OCINRESTService("get",apiProject+ 'projects/' +projectK).then(p =>{
        p1 = apmRESTService.OCINRESTServiceValidated("get",apiProject+ 'projects/' +projectK).then(p =>{
            _appCtxSvc.updateCtx("currentEngPrj",p.data.search)
        } );
    }
    let p2 = exports.oPINEngineeringSublocationPrereq();
    return Promise.all( [ p1, p2 ] ).then( x =>{
        changePrereqStatus( -1 );
        console.debug("###Prereq Exit oPINEngineeringProjectSublocationPrereq");
    } );
};
exports.oPINEngineeringSitePrereq = function() {
    console.debug("###Prereq Enter oPINEngineeringSitePrereq")
    changePrereqStatus( 1 );

    const TT = {
        'SitUaf': 'oPINEngineeringMessages',
        'SitUafDesc': 'oPINEngineeringMessages',
        'Mindsphere': 'oPINEngineeringMessages',
        'MindsphereDesc': 'oPINEngineeringMessages',
        'Cep': 'oPINEngineeringMessages',
        'CepDesc': 'oPINEngineeringMessages',
        'Other': 'oPINEngineeringMessages',
        'OtherDesc': 'oPINEngineeringMessages',
        'momap': 'oPINEngineeringMessages',
        'mommi': 'oPINEngineeringMessages'
    };

    const readdableDataSourceTypesCtx = _appCtxSvc.getCtx( 'readdableDataSourceTypes' );
    let pDst = Promise.resolve();
    if ( readdableDataSourceTypesCtx === null || readdableDataSourceTypesCtx === undefined ) {
        let TTTrad = Object.getOwnPropertyNames( TT ).map( x => {
            return localeService.getLocalizedText( TT[x], x );
        } );
        pDst = Promise.all( TTTrad ).then( tradArray => {
            Object.getOwnPropertyNames( TT ).forEach( ( x, index ) => {
                TT[x] = tradArray[ index ];
            } );

            const readdableDataSourceTypes = [];
            readdableDataSourceTypes[1] = TT['SitUaf'];
            readdableDataSourceTypes[2] = TT['Mindsphere'];
            readdableDataSourceTypes[3] = TT['Cep'];
            readdableDataSourceTypes[4] = TT['Other'];
            _appCtxSvc.registerCtx( 'readdableDataSourceTypes', readdableDataSourceTypes );
        } );
    }
    const readdableAssetModelsOwnershipsCtx =  _appCtxSvc.getCtx( 'readdableAssetModelsOwnerships' );
    let pAmo = Promise.resolve();
    if ( readdableAssetModelsOwnershipsCtx === null || readdableAssetModelsOwnershipsCtx === undefined ) {
        let TTTrad = Object.getOwnPropertyNames( TT ).map( x => {
            return localeService.getLocalizedText( TT[x], x );
        } );
        pAmo = Promise.all( TTTrad ).then( tradArray => {
            Object.getOwnPropertyNames( TT ).forEach( ( x, index ) => {
                TT[x] = tradArray[ index ];
            } );

            const readdableAssetModelsOwnerships = [];
            readdableAssetModelsOwnerships[1] = TT['momap'];
            readdableAssetModelsOwnerships[2] = TT['mommi'];
            _appCtxSvc.registerCtx( 'readdableAssetModelsOwnerships', readdableAssetModelsOwnerships );
        } );
    }

    return Promise.all( [ pDst, pAmo ] ).then( x =>{
        changePrereqStatus( -1 );
        console.debug("###Prereq Exit oPINEngineeringSitePrereq");
    } );
};
exports.oPINEngineeringSiteSublocationPrereq = function() {
    if ( !checkFeatures() ) {
        //momUtils.navigateTo("missingPage",null)
        alert("AssetPerformance feature not available")
        return Promise.reject(new Error("AssetPerformance feature not available"))
    }
    console.debug("###Prereq Enter oPINEngineeringSiteSublocationPrereq")
    changePrereqStatus(1);
    let p2 = exports.oPINEngineeringProjectSublocationPrereq();
    const currentEngSite = _appCtxSvc.getCtx("currentEngSite");
    let p1 = Promise.resolve();
    if ( currentEngSite === null || currentEngSite === undefined ) {
        const apiProject = _appCtxSvc.getCtx("oPINProjectsConfig").oPINEngineering.apiProject;
        //"ctx.oPINProjectsConfig.oPINEngineering.apiProject + 'projects/' + stateParams.engprojectid"
        var ss = _appCtxSvc.getCtx("state");
        //p1 = utilService.OCINRESTService("get",apiProject+ 'projects/' +ss.processed.engprojectid+'/plants/'+ss.processed.engsitetid+"?version="+ss.processed.engprjVer).then(p =>{
        p1 = apmRESTService.OCINRESTServiceValidated("get",apiProject+ 'projects/' +ss.processed.engprojectid+'/plants/'+ss.processed.engsitetid+"?version="+ss.processed.engprjVer).then(p =>{
            _appCtxSvc.updateCtx("currentEngSite",p.data.search)
        }, error =>{
            console.log("Error ",error)
        } );
    }
    return Promise.all( [ p1, p2 ] ).then( x =>{
        changePrereqStatus( -1 );
        console.debug("###Prereq Exit oPINEngineeringSiteSublocationPrereq");
    } );
};
exports.oPINEngineeringRTSublocationPrereq = function() {
    if ( !checkFeatures() ) {
        alert( 'AssetPerformance feature not available' );
        return Promise.reject(new Error('AssetPerformance feature not available' ));
    }
    console.debug( '###Prereq Enter oPINEngineeringRTSublocationPrereq' );
    changePrereqStatus( 1 );
    let p2 = exports.oPINEngineeringProjectSublocationPrereq();
    const currentEngRT = _appCtxSvc.getCtx( 'currentEngRT' );
    let p1 = Promise.resolve();
    if ( currentEngRT === null || currentEngRT === undefined ) {
        const apiTimemodel = _appCtxSvc.getCtx( 'oPINProjectsConfig' ).oPINEngineering.apiTimemodel;
        var ss = _appCtxSvc.getCtx( 'state' );
        
        //p1 = utilService.OCINRESTService( 'get', apiTimemodel + 'timemodels/' + ss.processed.engprojectid + '/reasontrees' + '?version=' + ss.processed.engprjVer ).then( p => {
        p1 = apmRESTService.OCINRESTServiceValidated( 'get', apiTimemodel + 'timemodels/' + ss.processed.engprojectid + '/reasontrees' + '?version=' + ss.processed.engprjVer ).then( p => {
            var currentRT = p.data.search.find( ( rt ) => { return rt.id === ss.processed.engrtid; } );
            _appCtxSvc.updateCtx( 'currentEngRT', currentRT );
        }, error => {
            console.log( 'Error ', error );
        } );
    }
    return Promise.all( [ p1, p2 ] ).then( x =>{
        changePrereqStatus( -1 );
        console.debug( '###Prereq Exit oPINEngineeringRTSublocationPrereq' );
    } );
};
export default new Proxy( exports, {
    get ( target, prop ) {
        if ( typeof target[ prop ] === 'function') {
            return new Proxy( target[prop], {
                apply: ( target, thisArg, argumentsList) => {
                    console.debug( "####utilService method call: " + prop, argumentsList );
                    return Reflect.apply( target, thisArg, argumentsList );
                }
            } );
        } else {
            return Reflect.get(target, prop);
        }
    }
} );
